module.exports = __webpack_public_path__ + "static/cobaLogo-2c188c87962df334d3c5478208ca5eb6.png";